<template>
    <layout :home_link="home_link">
        <a-breadcrumb class="px-4 pb-0 pt-4" :class="{ 'lg:hidden': !isEpicvaultEnabled, '': isEpicvaultEnabled }">
            <a-breadcrumb-item data-cy="breadcrumb-main">
                <a @click="$router.go(-1)">
                    <template v-if="isEpicvaultEnabled">
                        {{ $t('globals.navigation.header.covers_view.alt_title') }}
                    </template>
                    <template v-else>
                        {{ $t('globals.navigation.header.covers_view.title') }}
                    </template>
                </a>
            </a-breadcrumb-item>
            <a-breadcrumb-item data-cy="breadcrumb-sub">
                {{ $t('globals.navigation.header.covers_view.sub_title') }}
            </a-breadcrumb-item>
        </a-breadcrumb>
        <div v-if="!processing && cover_error" class="shadow-xl cover-details p-5">
            <div class="form-section">
                <div class="view-borderline flex flex-wrap w-full mb-2">
                    <div class="header-text w-full lg:w-1/5 pt-3 pl-2" data-cy="cover-detail-header">
                        {{ $t('covers.view.headers.details') }}
                    </div>
                </div>
                <div class="section-body w-full mb-8" data-cy="cover-details">
                    {{ $t('covers.notifications.error.no_cover_found_or_unauthorized_message') }}
                </div>
            </div>
        </div>
        <div v-if="!processing && !cover_error" class="shadow-xl cover-details p-5">
            <view-cover class="cover-view-form" data-cy="cover-view" :cover="cover" />
            <div
                class="header-text-vehicle w-full text-sm text-default-light-gray ml-2 font-bold"
                data-cy="vehicle-detail-header-vehicle"
            >
                {{ $t('covers.view.headers.vehicles') }}
            </div>
            <vehicle-table class="pb-8" data-cy="vehicle-table" :table_data="data" />
            <div class="flex flex-row justify-end">
                <a-button
                    v-if="isClaimsVaultEnabled"
                    class="m-2"
                    data-cy="check-claim-button"
                    @click="showModal"
                    type="primary"
                >
                    {{ $t('covers.view.buttons.claim') }} : {{ cover.claims_history }}
                </a-button>
                <a-button class="m-2" type="primary" @click="$router.go(-1)" data-cy="button-return-to-result">
                    {{ $t('covers.view.buttons.return-result') }}
                </a-button>
            </div>
        </div>
        <modal-claims :cover_id="cover_id" ref="ClaimsModal" />
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import ViewCover from '@/components/views/Cover.vue';
import UiButton from '@/components/ui/SubmitButton.vue';
import VehicleTable from '@/components/tables/CoverVehicle.vue';
import ModalClaims from '@/components/modals/Claims.vue';

export default {
    components: {
        Layout,
        ViewCover,
        UiButton,
        VehicleTable,
        ModalClaims,
    },
    data() {
        return {
            cover_id: this.$route.params.id,
            cover: {},
            data: [],
            home_link: {
                to: () => {
                    this.$router.go(-1);
                },
                label: this.$t('globals.navigation.header.covers_view.title'),
                default: false,
                module: 'cover',
            },
            processing: true,
            cover_error: false,
        };
    },
    computed: {
        isEpicvaultEnabled() {
            return this.$store.state.system.is_epicvault_enabled ? true : false;
        },
        isClaimsVaultEnabled() {
            return this.$store.state.user.modules.claimsvault;
        },
    },
    mounted() {
        this.fetch();
    },
    methods: {
        showModal() {
            this.$refs.ClaimsModal.showModal();
        },
        fetch() {
            const cover_id = this.$route.params.id;

            this.processing = true;

            this.$http
                .get('/api/covers/' + cover_id)
                .then((response) => {
                    if (response.data.status != undefined) {
                        if (response.data.status == 'error') {
                            this.cover_error = true;
                        }
                    } else {
                        let coverData = {
                            ...response.data.data,
                        };
                        this.cover = coverData;
                        this.data = [this.cover];
                    }
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'not-found',
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCVIEW10' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
    },
};
</script>
